import { BigNumber } from 'bignumber.js';
import { addSpacesEveryThree } from 'helpers';

export const parseDecimalValue = (value?: string): string | undefined => {
  if (value === undefined || value === '') return undefined;
  value = value.replace(/\s+/g, '').replace(',', '.');
  const bigNumber = BigNumber(value);
  if (bigNumber.isNaN()) return undefined;

  return bigNumber.toFixed();
};

export const formatDecimalValue = (
  value?: string,
  maxFloatingPoints = 2,
  maxIntegerLength = 13
): string => {
  if (value === undefined) return '';
  const normalizedValue = value.replace(/\s+/g, '').replace(',', '.');

  if (BigNumber(normalizedValue).isNaN()) return '';

  let [integer, floating] = normalizedValue.split('.');
  if (maxIntegerLength) {
    integer = integer.substring(0, maxIntegerLength);
  }
  integer = addSpacesEveryThree(integer);
  floating = floating?.slice(0, maxFloatingPoints);
  return [integer, floating].filter(Boolean).join(',');
};
